var _rect, _rect2, _rect3, _rect4, _rect5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleCommand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35.6306,
    height: 7.36842,
    fill: "url(#paint0_linear_193_15)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 10.3154,
    width: 35.6306,
    height: 7.36842,
    fill: "url(#paint1_linear_193_15)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20.6318,
    width: 35.6306,
    height: 7.36842,
    fill: "url(#paint2_linear_193_15)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3347,
    y: 4,
    width: 5.1429,
    height: 23.143,
    rx: 2.57145,
    transform: "rotate(44.8954 24.3347 4)",
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7.63672,
    width: 5.1429,
    height: 23.143,
    rx: 2.57145,
    transform: "rotate(-45 8 7.63672)",
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_193_15",
    x1: -3.5439e-7,
    y1: 4.36288,
    x2: 17.5231,
    y2: 17.8287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8044F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_193_15",
    x1: -3.5439e-7,
    y1: 14.6783,
    x2: 17.5231,
    y2: 28.1441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8044F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_193_15",
    x1: -3.5439e-7,
    y1: 24.9947,
    x2: 17.5231,
    y2: 38.4605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8044F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201E42"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCommand);
export default __webpack_public_path__ + "static/media/circle-command.48cdfea1b58b5de9f94fba940f0e5c7c.svg";
export { ForwardRef as ReactComponent };